import styled from 'styled-components';

const VARIANT_TYPES = {
  dark: {
    bgColor: '#3B4E5E',
    color: 'white',
    borderColor: '#3B4E5E'
  },
  light: {
    bgColor: 'white',
    color: 'black',
    borderColor: '#cfd2d4'
  }
};

export const Root = styled.span(props => {
  const { show, top, left, variant } = props;

  const { bgColor, color, borderColor } = VARIANT_TYPES[variant];

  return `
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: ${top}px;
    left: ${left}px;
    min-height: 20px;
    padding: 5px 8px;
    z-index: 99;
    width: max-content;
    color: ${color};
    background-color: ${bgColor};
    border-radius: 5px;
    border: 1px solid ${borderColor};
    box-shadow: 2px 2px 6px grey;
    visibility: ${show ? 'visible' : 'hidden'};

    &:before,
    &:after {
      bottom: 100%;
      left: 50%;
      border: solid transparent;
      content: "";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      visibility: ${show ? 'visible' : 'hidden'};
    }

    &:after {
      border-bottom-color: ${bgColor};
      border-width: 5px;
      margin-left: -5px;
    }

    &:before {
      border-bottom-color: ${borderColor};
      border-width: 7px;
      margin-left: -7px;
    }
  `;
});

export default Root;



// WEBPACK FOOTER //
// ./components/tooltip/styled.js